export { default } from '@relo/sports-components/es/AccordionList';
export * from '@relo/sports-components/es/AccordionList';
